import { t as defaultT } from 'i18next';

export const t = (key: string, params?: any) => {
  return defaultT(key, params) + '';
};
